import { render, staticRenderFns } from "./FormPrebidPartner.vue?vue&type=template&id=79a7e490&"
import script from "./FormPrebidPartner.vue?vue&type=script&lang=js&"
export * from "./FormPrebidPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports